module.exports = __webpack_public_path__ + "static/media/ruler-combined.3057219b.svg";